import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import {
    Box, Button, TextField, Typography, Card, CardContent, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Stack,
} from '@mui/material';
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import { renderScheduleWithTime } from '../Calendar/CalendarModule';
import { FaLocationDot, FaRegAddressCard, FaHouse } from "react-icons/fa6";
import { categories } from '../Calendar/EventModal';
import NoPhotographyIcon from '@mui/icons-material/NoPhotography';
import zIndex from '@material-ui/core/styles/zIndex';
import { MdOutlineRsvp } from 'react-icons/md';
import ApprovalIcon from '@mui/icons-material/Approval';

const EventApproveList = () => {


    const token = localStorage.getItem("calendar_admin");
    const user_Id = localStorage.getItem("userId");
    const isAdmin = localStorage.getItem('admin_user');
    const adminLvl = localStorage.getItem('admin_lvl');
    const [draftEventList, setDraftEventList] = useState([]);

    const approve_event = async (ID) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/approveEvent/${ID}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.data == 'ok') {
                toast.warning("Approved Event successfully");
                fetchDraftList();
            }
        } catch (error) {
            console.error("Error saving schedule:", error.message);
            toast.error("Failed to fetch schedule. Please try again later.");
        }
    }
    const fetchDraftList = async () => {
        // if (!token) return;
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/draftEvents/fetch`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.data == 'Empty') {
                toast.warning("Empty events");
            } else {
                setDraftEventList(response.data);
            }
        } catch (error) {
            console.error("Error saving schedule:", error.message);
            toast.error("Failed to fetch schedule. Please try again later.");
        }
    };
    useEffect(() => {
        fetchDraftList();
    }, []);



    return (
        <>
            <Box sx={{ alignContent: 'center' }}>
                <h3 style={{ zIndex: '10' }}>Approving Event List</h3>
                <Box component={Paper} sx={{ zIndex: 10, width: '100%', maxHeight: '1000px', msOverflowY: 'auto', alignContent: 'center' }}>

                    {draftEventList.map((event) => (
                        <Box sx={{
                            flexDirection: 'column',
                            gap: '0.5rem',
                            fontSize: '1rem',
                            backgroundColor: '#e0fcff',
                            margin: '1rem',
                            padding: '0.5rem',
                            borderRadius: '8px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                            justifyContent: 'space-between', // Ensure spacing between child elements
                        }}>
                            <Box
                                sx={{
                                    margin: '0 auto',
                                    padding: { xs: '0rem 0.5rem 0rem 0.5rem', md: '0rem 1rem 0rem 1rem' },
                                    display: 'flex',
                                    flexDirection: { xs: 'column', md: 'row' },
                                    gap: '1.5rem',
                                    alignItems: 'stretch', // Ensures all children have the same height
                                }}
                            >
                                {/* Event Details */}
                                <Box
                                    sx={{
                                        flex: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '0.5rem',
                                        justifyContent: 'space-between', // Distribute content evenly within the box
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <b style={{ fontSize: '1rem', textAlign: 'center' }}>{event.userId.name} / {event.userId.email}</b>
                                    </Box>

                                    <Box sx={{ justifyContent: 'center', justifyItems: 'center', justifySelf: 'center' }}>
                                        {event.cimage ? (
                                            <img
                                                src={event.cimage}
                                                alt="Event"
                                                style={{ width: '100%', maxWidth: '15rem', borderRadius: '8px' }}
                                            />
                                        ) : <NoPhotographyIcon />}
                                    </Box>
                                    <Typography sx={{ gap: '15px' }}>
                                        <Fab color="secondary" aria-label="edit" size="small" onClick={() => approve_event(event._id)} >
                                            <ApprovalIcon />
                                        </Fab>
                                    </Typography>
                                </Box>

                                {/* Details Box */}
                                {/* <Stack direction="column" justifyContent="space-between" spacing={}>

                            </Stack> */}
                                <Box
                                    sx={{
                                        flex: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '0.5rem',
                                        fontSize: '0.9rem',
                                        justifyContent: 'space-between', // Ensure spacing between child elements
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <b style={{ fontSize: '1rem', textAlign: 'center' }}>{event.title}</b>
                                    </Box>

                                    <Box>
                                        <span className="todo-dates" style={{ color: 'gray' }}>
                                            {renderScheduleWithTime(event.start, event.end)}
                                        </span>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                        <FaHouse className="icon" />
                                        <span style={{ marginLeft: '0.5rem' }}>{event.location}</span>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                        <FaLocationDot className="icon" />
                                        <span style={{ marginLeft: '0.5rem' }}>{event.address}</span>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                        <Link
                                            href={`${event.link.startsWith('http://') || event.link.startsWith('https://') ? '' : 'https://'}${event.link}`}
                                            target="_blank"
                                            fontSize={'1rem'}
                                            sx={{ color: 'primary.main', textDecoration: 'underline' }}
                                        >
                                            {event.link}
                                        </Link>
                                    </Box>
                                    <Box sx={{ fontSize: '1rem', textWrap: 'wrap', flex: 1 }}>
                                        {event.description}
                                    </Box>
                                    <Box
                                        sx={{
                                            // display: "flex",
                                            // flexDirection: "column",
                                            // alignItems: "flex-start",
                                            gap: "1rem",
                                            // flex: 1,
                                        }}
                                    >
                                        {
                                            event.rsvp &&
                                            <span style={{
                                                fontSize: '1rem',
                                                color: 'gray',
                                                border: '1px solid #ccc', // Light gray border
                                                // padding: '0.5rem 1rem',    // Padding inside the rectangle
                                                borderRadius: '0.5rem',       // Rounded corners (optional)
                                                display: 'inline-block',    // Makes the span behave like a block element, allowing padding and border to apply
                                                // margin: '0.3rem'
                                            }}>

                                                <MdOutlineRsvp style={{ fontSize: '2rem', color: 'green' }} />
                                                {/* RSVP required */}
                                            </span>}
                                        {event.selectedCategory.map((item, index) => (
                                            <span
                                                key={index}
                                                style={{
                                                    color: categories[item]['color'],
                                                    fontSize: '1rem',
                                                    // display: "flex",
                                                    alignItems: "center",
                                                    margin: '0.3rem'
                                                }}
                                            >
                                                {categories[item]['icon']}&nbsp;{item}
                                            </span>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>

                        </Box>

                    ))}

                </Box>
            </Box>

        </>
    );
};

export default EventApproveList;
